import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentStateInterface, OnFieldChangeType } from '../../../../../../@types/types'
import { loadCountries } from '../../../../../../redux/thunks/internationalAddress/internationalAddress'
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { SCREEN_ADDRESS, SCREENS } from '../../../../../../services/domain/wizardScreens'
import Checkbox from '../../../../../common/inputs/checkbox/Checkbox'

export type ReadOnlyAddressProps = {
  insertionData: ContentStateInterface
  onChange: OnFieldChangeType
}

const ReadOnlyAddress: React.FC<ReadOnlyAddressProps> = ({ insertionData, onChange }) => {
  const screen = SCREENS[SCREEN_ADDRESS]
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const { manualGeoCoding } = useAppSelector((initial: InitState) => initial.addressFeature)

  useEffect(() => {
    insertionData.manualCountry?.value && !manualGeoCoding.countries.length && dispatch(loadCountries())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div data-testid='readonly-address-container'>
      <div className='font-default-color'>
        <p className={'pii-hide'}>
          {insertionData.street} {insertionData.houseNumber}
        </p>
        <p className={'pii-hide'}>
          {insertionData.postcode} {insertionData.city}
        </p>
        <p>{manualGeoCoding.countries.find((value) => value.value === insertionData.manualCountry?.value)?.label}</p>
      </div>
      <div className='grid-item one-whole'>
        <Checkbox
          id='address-show-street-and-street-number'
          name='hideStreetAndStreetNumber'
          label={<span>{t('wizard.screen.readOnlyAddress.visibility', 'Show address to interested people')}</span>}
          checked={!insertionData.hideStreetAndStreetNumber}
          onChange={(property, value) => onChange({ screen: screen.name, property }, !value)}
        />
      </div>
    </div>
  )
}

export default ReadOnlyAddress
